var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{model:{value:(_vm.showdialog),callback:function ($$v) {_vm.showdialog=$$v},expression:"showdialog"}},[_c('v-card',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }